import { createSelector } from '@reduxjs/toolkit';

import { rootStateBranchSelector } from '../rootStateBranchSelector';

export const getResidentialComplexes = rootStateBranchSelector('residentialComplexes');

export const residentialComplexesListSelector = createSelector(getResidentialComplexes, state => state.list);
export const residentialComplexesHashSelector = createSelector(getResidentialComplexes, state => state.hash);
